<template>
    <div class="accountingentry-search">
        <b-row>
            <b-col md="10" sm="12">
                <PageTitle
                    icon="fa fa-search"
                    main="Controle"
                    sub="Pesquisa de Lançamentos Contábeis"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    @click="startNewAccountEntry"
                    variant="light"
                    class="mr-2 mt-2 fa fa-plus"
                ></b-button>
                <b-button
                    size="sm"
                    title="Razão Analítico"
                    @click="printerAnalitic"
                    variant="light"
                    class="mr-2 mt-2 fa fa-print"
                ></b-button>
                <b-button
                    size="sm"
                    class=" mt-2 fa"
                    :class="icon"
                    @click=";[loadAccountingEntrys()]"
                    variant="light"
                ></b-button>
            </b-col>
        </b-row>
        <hr />
        <b-row>
            <b-col md="5" sm="12">
                <b-form-group
                    label="Empresa:"
                    label-for="accountingentry-search-company_id"
                >
                    <b-form-select
                        id="accountingentry-search-company_id"
                        @input="loadAccountingEntrys"
                        size="sm"
                        :options="companys"
                        v-model="company_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Conciliado:"
                    label-for="accountingentry-search-receipt"
                >
                    <b-form-select
                        id="accountingentry-search-receipt"
                        @input="loadAccountingEntrys"
                        size="sm"
                        :options="questionboxyesnoalls"
                        v-model="conciliation"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="1" sm="2">
                <b-form-group label="ID" label-for="accountplan-id">
                    <b-form-input
                        id="accountplan-id"
                        type="text"
                        v-model="account_plan_id"
                        @input="setAccountPlan()"
                        size="sm"
                        placeholder="ID..."
                    />
                </b-form-group>
            </b-col>
            <b-link
                v-b-modal.modalAccountPlan
                class="fa fa-search mt-4"
            ></b-link>
            <b-col md="4" sm="8">
                <b-form-group
                    label="Descrição Conta Contábil:"
                    label-for="accountplan-name_account_plan"
                >
                    <b-form-input
                        id="accountplan-name_account_plan"
                        type="text"
                        v-model="accountplan.name_account_plan"
                        size="sm"
                        :readonly="true"
                        placeholder="Nome..."
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="2">
                <b-form-group
                    label="Código Conta Contábil:"
                    label-for="accountplan-internal_code_account_plan"
                >
                    <b-form-input
                        id="accountplan-internal_code_account_plan"
                        type="text"
                        v-model="accountplan.internal_code_account_plan"
                        size="sm"
                        :readonly="true"
                        placeholder=""
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="1" sm="2">
                <b-form-group label="ID" label-for="entity-id">
                    <b-form-input
                        id="entity-id"
                        type="text"
                        v-model="entity_id"
                        @input=";[setEntity()]"
                        size="sm"
                        placeholder="Código..."
                    />
                </b-form-group>
            </b-col>
            <b-link v-b-modal.modalEntity class="fa fa-search mt-4"> </b-link>
            <b-col md="4" sm="8">
                <b-form-group
                    label="Razão Social:"
                    label-for="entity-name_entity"
                >
                    <b-form-input
                        id="entity-name_entity"
                        type="text"
                        v-model="entity.name_entity"
                        size="sm"
                        :readonly="true"
                        placeholder="Nome..."
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="2">
                <b-form-group
                    label="CPF/CNPJ/Banco/Caixa:"
                    label-for="entity-cnpj_cpf"
                >
                    <b-form-input
                        id="entity-cnpj_cpf"
                        type="text"
                        v-model="entity.cnpj_cpf"
                        size="sm"
                        :readonly="true"
                        placeholder=""
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Início:"
                    label-for="accountingentry-search-start_date"
                >
                    <b-form-input
                        id="release-search-start_date"
                        type="date"
                        v-model="start_date"
                        ref="inputFist"
                        v-on:keyup.enter="
                            ;[loadAccountingEntrys, (showTable = true)]
                        "
                        @input="loadAccountingEntrys"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Término:"
                    label-for="accountingentry-search-end_date"
                >
                    <b-form-input
                        id="release-search-end_date"
                        type="date"
                        v-model="end_date"
                        v-on:keyup.enter="
                            ;[loadAccountingEntrys, (showTable = true)]
                        "
                        @input="loadAccountingEntrys"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" sm="12">
                <template>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                    ></b-pagination>
                    <transition name="slide" type="animation" appear>
                        <b-table
                            id="my-table"
                            class="table-responsive"
                            :per-page="perPage"
                            head-variant="light"
                            :current-page="currentPage"
                            hover
                            key="slide"
                            :items="accountingentrys"
                            :fields="fieldsAccounting"
                        >
                            <template v-slot:table-busy>
                                <div class="text-center text-info my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Carregando...</strong>
                                </div>
                            </template>
                            <template v-slot:cell(actions)="data">
                                <b-button
                                    title="Editar registro"
                                    size="sm"
                                    variant="light"
                                    @click="actionEditChangeTracking(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-pencil"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </transition>
                </template>
            </b-col>
        </b-row>
        <b-modal
            id="modalEntity"
            ref="modal"
            hide-footer
            title-tag="h6"
            size="lg"
            @shown="focusModalEntity"
            title="Consulta de Cliente/Fornecedor/Caixa/Banco"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-row>
                    <b-col md="6" sm="8">
                        <b-form-group
                            label="Nome:"
                            label-for="entity-name_entity"
                        >
                            <b-form-input
                                id="entity-name_entity"
                                type="text"
                                v-model="entity.name_entity"
                                size="sm"
                                :readonly="true"
                                placeholder="Nome..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="2">
                        <b-form-group
                            label="CPF/CNPJ/Banco/Caixa:"
                            label-for="entity-cnpj_cpf"
                        >
                            <b-form-input
                                id="entity-cnpj_cpf"
                                type="text"
                                v-model="entity.cnpj_cpf"
                                size="sm"
                                :readonly="true"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="control-label">
                                <i class="fa fa-search"></i>
                                Pesquisar
                            </label>
                            <b-button
                                size="sm"
                                class=" ml-2 mb-2 fa fa-search"
                                @click=";[loadEntitys()]"
                                variant="outline-secondary"
                            ></b-button>
                            <b-form-select
                                id="accountingentry-search-type_entity_id"
                                @input=";[loadEntitys(), (showEntity = true)]"
                                size="sm"
                                ref="focusEntity"
                                class="mb-2"
                                :options="typeentitys"
                                v-model="type_entity_id"
                            />
                            <input
                                type="text"
                                icon="search"
                                v-model="searchEntity"
                                placeholder="Informe o nome/CPF-CNPJ"
                                class="form-control"
                            />
                        </div>
                    </div>
                </b-row>
                <b-table
                    class="table-responsive"
                    hover
                    striped
                    v-show="showEntity"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :items="filteredListEntity"
                    :fields="fieldsEntity"
                >
                    <template slot="actions" slot-scope="data">
                        <b-button
                            title="Selecionar o registro"
                            size="sm"
                            variant="outline-secondary"
                            @click="
                                ;[
                                    setSearchEntity(data.item),
                                    (showEntity = !showEntity),
                                    hideModal()
                                ]
                            "
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-check-square-o"></i>
                        </b-button>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rowsEntity"
                    :per-page="perPage"
                    aria-controls="my-table"
                ></b-pagination>
            </b-form>
        </b-modal>

        <b-modal
            id="modalAccountPlan"
            ref="modal"
            hide-footer
            @shown="focusModalAccountPlan"
            title-tag="h6"
            size="lg"
            title="Consulta do Plano de Contas"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-row>
                    <b-col md="6" sm="8">
                        <b-form-group
                            label="Nome:"
                            label-for="accountplan-name_account_plan"
                        >
                            <b-form-input
                                id="accountplan-name_account_plan"
                                type="text"
                                v-model="accountplan.name_account_plan"
                                size="sm"
                                :readonly="true"
                                placeholder="Nome..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="2">
                        <b-form-group
                            label="Código Contábil:"
                            label-for="accountplan-internal_code_account_plan"
                        >
                            <b-form-input
                                id="accountplan-internal_code_account_plan"
                                type="text"
                                v-model="accountplan.internal_code_account_plan"
                                size="sm"
                                :readonly="true"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="control-label">
                                <i class="fa fa-search"></i> Pesquisar
                            </label>
                            <b-button
                                size="sm"
                                class=" ml-2 mb-2 fa fa-search"
                                @click="
                                    ;[
                                        loadAccountPlans(),
                                        (showAccountPlan = !showAccountPlan)
                                    ]
                                "
                                variant="secondary"
                            ></b-button>
                            <input
                                type="text"
                                icon="search"
                                ref="focusAccPlan"
                                v-on:keyup.enter="
                                    ;[
                                        loadAccountPlans(),
                                        (showAccountPlan = !showAccountPlan)
                                    ]
                                "
                                v-model="searchAccountPlan"
                                placeholder="Informe o Descrição/Código Contábil"
                                class="form-control"
                            />
                        </div>
                    </div>
                </b-row>
                <b-table
                    class="table-responsive"
                    hover
                    striped
                    v-show="showAccountPlan"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :items="filteredListAccountPlan"
                    :fields="fieldsAccountPlan"
                >
                    <template v-slot:cell(actions)="data">
                        <b-button
                            title="Selecionar o registro"
                            v-show="!data.item.synthetic"
                            size="sm"
                            variant="secondary"
                            @click="
                                ;[
                                    setSearchAccountPlan(data.item),
                                    (showAccountPlan = !showAccountPlan),
                                    hideModal()
                                ]
                            "
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-check-square-o"></i>
                        </b-button>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rowsAccountPlan"
                    :per-page="perPage"
                    aria-controls="my-table"
                ></b-pagination>
            </b-form>
        </b-modal>
        <b-modal
            id="modalAccountingEntry"
            ref="modal"
            size="lg"
            @shown="focusModalAccountingEntry"
            title-tag="h6"
            title="Lançamento Contábil"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveAccountingEntry"
        >
            <b-form>
                <b-row>
                    <b-col md="1" sm="2">
                        <b-form-group label="ID" label-for="accountingentry-id">
                            <b-form-input
                                id="accountingentry-id"
                                type="text"
                                v-model="
                                    accountingentry.accounting_account_plan_id
                                "
                                @input="
                                    setAccountPlan(
                                        accountingentry.accounting_account_plan_id
                                    )
                                "
                                size="sm"
                                v-on:keyup.enter="openModalAccountPlan"
                                ref="focusAccEntry"
                                placeholder="ID..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-link
                        v-b-modal.modalAccountPlan
                        class="fa fa-search mt-4"
                    ></b-link>
                    <b-col md="7" sm="8">
                        <b-form-group
                            label="Descrição Conta Contábil:"
                            label-for="accountplan-name_account_plan"
                        >
                            <b-form-input
                                id="accountplan-name_account_plan"
                                type="text"
                                v-model="accountplan.name_account_plan"
                                size="sm"
                                :readonly="true"
                                placeholder="Nome..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="2">
                        <b-form-group
                            label="Código Conta Contábil:"
                            label-for="accountplan-internal_code_account_plan"
                        >
                            <b-form-input
                                id="accountplan-internal_code_account_plan"
                                type="text"
                                v-model="accountplan.internal_code_account_plan"
                                size="sm"
                                :readonly="true"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Lançamento em:"
                            label-for="accountingentry-accounting_date"
                        >
                            <b-form-input
                                id="accountingentry-accounting_date"
                                type="date"
                                v-model="accountingentry.accounting_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Valor:"
                            label-for="accountingentry-accounting_value"
                        >
                            <b-form-input
                                id="accountingentry-accounting_value"
                                v-model="accountingentry.accounting_value"
                                type="number"
                                ref="inputAccPlannext"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Centro de Custo/Receita:"
                            label-for="accountingentry-accounting_cost_center_id"
                        >
                            <b-form-select
                                id="accountingentry-accounting_cost_center_id"
                                size="sm"
                                :options="costcenters"
                                v-model="
                                    accountingentry.accounting_cost_center_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Custo:"
                            label-for="accountingentry-accounting_type_cost_id"
                        >
                            <b-form-select
                                id="accountingentry-accounting_type_cost_id"
                                size="sm"
                                :options="typecosts"
                                v-model="
                                    accountingentry.accounting_type_cost_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group label="Natureza:">
                            <b-form-radio-group
                                v-model="
                                    accountingentry.accounting_nature_account
                                "
                                :options="options_nature"
                                name="accountingentry-accounting_nature_account"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="1" sm="2">
                        <b-form-group
                            label="ID"
                            label-for="accountingentry_entity-id"
                        >
                            <b-form-input
                                id="accountingentry_entity-id"
                                type="text"
                                v-model="accountingentry.accounting_entity_id"
                                @input="
                                    ;[
                                        setEntity(
                                            accountingentry.accounting_entity_id
                                        )
                                    ]
                                "
                                v-on:keyup.enter="openModalEntity"
                                size="sm"
                                placeholder="Código..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-link v-b-modal.modalEntity class="fa fa-search mt-4">
                    </b-link>
                    <b-col md="7" sm="8">
                        <b-form-group
                            label="Razão Social:"
                            label-for="entity-name_entity"
                        >
                            <b-form-input
                                id="entity-name_entity"
                                type="text"
                                v-model="entity.name_entity"
                                size="sm"
                                :readonly="true"
                                placeholder="Nome..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="2">
                        <b-form-group
                            label="CPF/CNPJ/Banco/Caixa:"
                            label-for="entity-cnpj_cpf"
                        >
                            <b-form-input
                                id="entity-cnpj_cpf"
                                type="text"
                                v-model="entity.cnpj_cpf"
                                size="sm"
                                :readonly="true"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Operação:"
                            label-for="accountingentry-accounting_operation_id"
                        >
                            <b-form-select
                                id="accountingentry-accounting_operation_id"
                                @input="loadOperationsLevelOnes"
                                size="sm"
                                :options="operations"
                                v-model="
                                    accountingentry.accounting_operation_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="1º Nível:"
                            label-for="accountingentry-accounting_operation_level_one_id"
                        >
                            <b-form-select
                                id="accountingentry-accounting_operation_level_one_id"
                                @input="loadOperationsLevelTwos"
                                size="sm"
                                :options="operationslevelones"
                                v-model="
                                    accountingentry.accounting_operation_level_one_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="5" sm="12">
                        <b-form-group
                            label="2º Nível:"
                            label-for="accountingentry-accounting_operation_level_two_id"
                        >
                            <b-form-select
                                id="accountingentry-accounting_operation_level_two_id"
                                size="sm"
                                :options="operationsleveltwos"
                                v-model="
                                    accountingentry.accounting_operation_level_two_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="10" sm="12">
                        <b-form-group
                            label="Histórico:"
                            label-for="accountingentry-accounting_comments"
                        >
                            <b-form-textarea
                                id="accountingentry-accounting_comments"
                                :rows="3"
                                :max-rows="6"
                                ref="inputEntitynext"
                                size="sm"
                                v-model="accountingentry.accounting_comments"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
var moment = require('moment')

export default {
    name: 'AccountingEntrySearch',
    components: { PageTitle },
    data: function() {
        return {
            mode: 'insert',
            modeChangeTracking: 'insert',
            conciliation: null,
            start_date: null,
            end_date: null,
            company_id: null,
            type_entity_id: null,
            entity_id: null,
            account_plan_id: null,
            isBusy: false,
            search: '',
            searchEntity: '',
            searchAccountPlan: '',
            accountingentry: {},
            accountplans: [],
            accountingentrys: [],
            documentstatus: [],
            entity: {},
            accountplan: {},
            entitys: [],
            entitysshearch: [],
            companys: [],
            questionboxyesnoalls: [],
            typeentitys: [],
            costcenters: [],
            operations: [],
            operationsleveltwos: [],
            operationslevelones: [],
            typecosts: [],
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            showTable: false,
            showChangeTracking: false,
            showEntity: false,
            showAccountPlan: false,
            perPage: 5,
            currentPage: 1,
            options_nature: [
                { text: 'Crédito', value: 'C' },
                { text: 'Débito', value: 'D' }
            ],
            fieldsAccounting: [
                {
                    key: 'accounting_date',
                    label: 'Contabilizado',
                    sortable: false,
                    formatter: value =>
                        value ? moment(value).format('DD-MM-YYYY') : ''
                },
                { key: 'account_plan', label: 'Conta', sortable: false },
                {
                    key: 'account_name_plan',
                    label: 'Descrição',
                    sortable: false
                },
                {
                    key: 'accounting_nature_account',
                    label: 'Nat.',
                    sortable: false
                },
                { key: 'accounting_value', label: 'Valor', sortable: false },
                { key: 'account_against', label: 'CP-Conta', sortable: false },
                {
                    key: 'account_name_against',
                    label: 'CP-Descrição',
                    sortable: false
                },
                {
                    key: 'accounting_comments',
                    label: 'Historico',
                    sortable: false
                },
                {
                    key: 'accounting_conciliation_date',
                    label: 'Conciliado',
                    sortable: false,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsEntity: [
                { key: 'id', label: 'Código', sortable: true },
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ/Código', sortable: false },
                { key: 'name_type_entity', label: 'Tipo', sortable: false },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsAccountPlan: [
                { key: 'id', label: 'ID', sortable: true },
                {
                    key: 'internal_code_account_plan',
                    label: 'Conta',
                    sortable: true
                },
                {
                    key: 'name_account_plan',
                    label: 'Descrição',
                    sortable: false
                },
                {
                    key: 'synthetic',
                    label: 'Sintético',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                { key: 'actions', label: 'Ações' }
            ]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        filteredListEntity() {
            return this.entitysshearch.filter(entity => {
                return (
                    entity.name_entity
                        .toLowerCase()
                        .includes(this.searchEntity.toLowerCase()) ||
                    entity.cnpj_cpf
                        .toLowerCase()
                        .includes(this.searchEntity.toLowerCase())
                )
            })
        },
        filteredListAccountPlan() {
            return this.accountplans.filter(accountplan => {
                return (
                    accountplan.name_account_plan
                        .toLowerCase()
                        .includes(this.searchAccountPlan.toLowerCase()) ||
                    accountplan.internal_code_account_plan
                        .toLowerCase()
                        .includes(this.searchAccountPlan.toLowerCase())
                )
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.accountingentrys.length
        },
        rowsEntity() {
            return this.entitysshearch.length
        },
        rowsAccountPlan() {
            return this.accountplans.length
        }
    },
    methods: {
        formatDate(date) {
            return moment.utc(date).format('YYYY-MM-DD')
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        async loadEntitys() {
            if (this.compan.id) {
                const url = `${baseApiUrl}/entitysallcompany/${this.compan.id}/?type_entity_id=${this.type_entity_id}`
                await axios.get(url).then(res => {
                    this.entitysshearch = res.data
                })
            } else {
                this.$toasted.global.defaultError({ msg: 'Logar na Empresa' })
            }
        },
        async loadAccountPlans() {
            const url = `${baseApiUrl}/accountplans/?blocked=${0}`
            await axios.get(url).then(res => {
                this.accountplans = res.data
            })
        },
        async loadAccountingEntrys() {
            const url = `${baseApiUrl}/accountingentryssearch/${this.company_id}/?conciliation=${this.conciliation}&entity_id=${this.entity_id}&start_date=${this.start_date}&end_date=${this.end_date}&account_plan_id=${this.account_plan_id}`
            await axios.get(url).then(res => {
                this.accountingentrys = res.data
            })
        },
        async setEntity(entity) {
            const url = `${baseApiUrl}/entitys/${entity}`
            await axios(url).then(res => (this.entity = res.data))

            this.$refs.inputEntitynext.focus()
        },
        async setAccountPlan(accountplan) {
            const url = `${baseApiUrl}/accountplans/${accountplan}`
            await axios(url).then(res => (this.accountplan = res.data))

            this.$refs.inputAccPlannext.focus()
        },
        async loadCompanys() {
            const url = `${baseApiUrl}/companys`
            await axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        },
        async loadQuestionBoxYesNoAlls() {
            const url = `${baseApiUrl}/questionboxyesnoalls`
            await axios.get(url).then(res => {
                this.questionboxyesnoalls = res.data.map(
                    questionboxyesnoall => {
                        return {
                            value: questionboxyesnoall.id,
                            text: questionboxyesnoall.name_question_box
                        }
                    }
                )
            })
            this.conciliation = 0
        },
        async loadTypeEntitys() {
            const url = `${baseApiUrl}/typeentitysall`
            await axios.get(url).then(res => {
                this.typeentitys = res.data.map(typeentity => {
                    return { value: typeentity.id, text: typeentity.name }
                })
            })
        },
        setSearchEntity(entity) {
            this.entity_id = entity.id
            this.accountingentry.accounting_entity_id = entity.id
            this.entity = { ...entity }

            this.$refs.inputEntitynext.focus()
        },
        setSearchAccountPlan(accountplan) {
            this.account_plan_id = accountplan.id
            this.accountingentry.accounting_account_plan_id = accountplan.id
            this.accountplan = { ...accountplan }

            this.$refs.inputAccPlannext.focus()
        },
        startNewAccountEntry() {
            if (!this.compan) {
                this.$toasted.global.defaultError({ msg: 'Logar na Empresa' })
            } else {
                this.accountingentry = {}
                const date = new Date()
                this.accountingentry = {
                    ...this.accountingentry,
                    accounting_date: moment(date).format('YYYY-MM-DD')
                }
                this.$bvModal.show('modalAccountingEntry')
            }
        },
        hideModal() {
            this.$bvModal.hide('modalEntity')
            this.$bvModal.hide('modalAccountPlan')
        },
        async loadOperation() {
            const url = `${baseApiUrl}/operations`
            await axios.get(url).then(res => {
                this.operations = res.data.map(operation => {
                    return {
                        value: operation.id,
                        text: operation.name_operation
                    }
                })
            })
        },
        async loadOperationsLevelOnes() {
            const url = `${baseApiUrl}/operationslevelones/${this.accountingentry.accounting_operation_id}/operations`
            await axios.get(url).then(res => {
                this.operationslevelones = res.data.map(operationslevelone => {
                    return {
                        value: operationslevelone.id,
                        text: operationslevelone.name_operation_level_one
                    }
                })
            })
        },
        async loadOperationsLevelTwos() {
            const url = `${baseApiUrl}/operationsleveltwos/${this.accountingentry.accounting_operation_level_one_id}/operationslevelones`
            await axios.get(url).then(res => {
                this.operationsleveltwos = res.data.map(operationsleveltwo => {
                    return {
                        value: operationsleveltwo.id,
                        text: operationsleveltwo.name_operation_level_two
                    }
                })
            })
        },
        async loadCostCenter() {
            const url = `${baseApiUrl}/costcenteranalitic/${this.compan.id}`
            await axios.get(url).then(res => {
                this.costcenters = res.data.map(costcenter => {
                    return {
                        value: costcenter.id,
                        text: costcenter.name_cost_center
                    }
                })
            })
        },
        async loadTypeCost() {
            const url = `${baseApiUrl}/typecosts`
            await axios.get(url).then(res => {
                this.typecosts = res.data.map(typecost => {
                    return { value: typecost.id, text: typecost.name_type_cost }
                })
            })
        },
        async saveAccountingEntry() {
            if (this.accountingentry.id) {
                this.accountingentry.user_update_id = this.user.id
                this.accountingentry.update_date = this.formatDate(moment.utc())
            } else {
                this.accountingentry.user_id = this.user.id
            }
            this.accountingentry.accounting_company_id = this.compan.id
            const method = this.accountingentry.id ? 'put' : 'post'
            const id = this.accountingentry.id
                ? `/${this.accountingentry.id}`
                : ''

            await axios[method](
                `${baseApiUrl}/accountingentrys${id}`,
                this.accountingentry
            )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadAccountingEntrys()
                })
                .catch(showError)
        },
        focusModalAccountingEntry() {
            this.$refs.focusAccEntry.focus()
        },
        focusModalAccountPlan() {
            this.$refs.focusAccPlan.focus()
        },
        focusModalEntity() {
            this.$refs.focusEntity.focus()
        },
        openModalAccountPlan() {
            this.$bvModal.show('modalAccountPlan')
        },
        openModalEntity() {
            this.$bvModal.show('modalEntity')
        },
        async printerAnalitic() {
            if (!this.start_date || !this.end_date) {
                this.$toasted.global.defaultWarning({
                    msg: 'Data não informada'
                })
            } else if (!this.company_id) {
                this.$toasted.global.defaultWarning({
                    msg: 'Empresa não informada'
                })
            } else {
                const url = `${baseApiUrl}/accountingentrysanaliticsprinter/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}`
                await axios.get(url)
                window.open(url)
            }
        }
    },
    mounted() {
        this.loadCompanys()
        this.loadQuestionBoxYesNoAlls()
        this.loadTypeEntitys()
        this.loadOperation()
        this.loadCostCenter()
        this.loadTypeCost()
        this.$refs.inputFist.focus()

        if (this.compan) {
            this.company_id = this.compan.id
        } else {
            this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
        }

        const date = new Date()
        this.start_date = moment(date).format('YYYY-MM-DD')
        this.end_date = moment(date).format('YYYY-MM-DD')
    }
}
</script>

<style>
.accountingentry-search {
    font-size: 0.7rem;
}

.accountingentry-search input,
label,
form {
    font-size: 0.7rem;
}
.accountingentry-search button {
    font-size: 0.7rem;
}

.accountingentry-search select {
    font-size: 0.7rem;
}

.accountingentry-search table {
    font-size: 0.7rem;
}

#modalAccountPlan {
    font-size: 0.7rem;
}

#modalAccountPlan input,
label,
form {
    font-size: 0.7rem;
}
#modalAccountPlan button {
    font-size: 0.7rem;
}

#modalAccountPlan select {
    font-size: 0.7rem;
}

#modalAccountingEntry {
    font-size: 0.7rem;
}

#modalAccountingEntry input,
label,
form {
    font-size: 0.7rem;
}
#modalAccountingEntry button {
    font-size: 0.7rem;
}

#modalAccountingEntry select {
    font-size: 0.7rem;
}

#modalAccountingEntry textarea {
    font-size: 0.7rem;
}

#modalEntity {
    font-size: 0.7rem;
}

#modalEntity input,
label,
form {
    font-size: 0.7rem;
}
#modalEntity button {
    font-size: 0.7rem;
}

#modalEntity select {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
